export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/price-adjustment`,
        name: `${prefix}.price-adjustment.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.price-adjustment.index`,
                PageDescription: "Inventory management: Price adjustment",
            },
        },
    },
];
